// extracted by mini-css-extract-plugin
module.exports = {"svg":"IconSvg_svg_3vasY"};